function arrSeparator({ arr }) {
  if (!arr) {
    return "";
  }
  return arr.map((item) => item).join(" - ");
}

export default arrSeparator;
